export default __webpack_public_path__ + "static/media/bg-4of7.3ce6897d.svg";